<template>
  <div>
      <header class="formWidgetHeader">
        <div class="widgetHeaderWrapper">
            <div class="formNavGroup navGroupLeft">
            <router-link :to="{ name: 'offtaker.dashboard' }" class="navGroupItem formClose" title="Skip this Setup">
                Skip
            </router-link>
            <router-link :to="{ name: 'offtaker.accountSetupOne'}" title="Previous Step" class="navGroupItem navBack">
                <svg class="cust_icon" viewBox="0 0 30 30" fill="none" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.575 13.9394L9.51447 14.9999L18 23.4854L20.121 21.3644L13.758 14.9999L20.121 8.6354L18 6.5144L10.575 13.9394Z"/>
                </svg>
            </router-link>
            </div>
            <div class="formNavGroup navGroupCenter">
            <div class="navGroupItem formTitle">
                <h4 class="title font-bold caps_upper">Setup your account</h4>
            </div>
            </div>
            <div class="formNavGroup navGroupRight">
                <submit-button class="navGroupItem formSubmit" :disabled="checkFields || submitting" @click="completedBoarding">
                    Complete
                </submit-button>
            </div>
        </div>
    </header>

    <main class="mainContentArea">
        <div class="formWidgetWrapper row no-gutters">
            <section class="formWidgetbody bg__white col-md-9 col-lg-8">
                <div class="section_block">
                    <div class="container form_body">
                        <div class="section_header font-md">
                            <h3 class="title title_md color__black font-bold">Update your Profile</h3>
                        </div>
                        <div class="content_inner">
                            <form action="#" @submit.prevent="submitForm">
                                <div class="user_profile_details">
                                    <div class="user_info_avi avi_lg">
                                        <img :src="img" alt="" style="width: 100%; height: 100%;">
                                        <span class="default_avi">{{user.fullName | initials}}</span>
                                    </div>
                                    <div class="user_details_wrapper">
                                        <div class="user_info">
                                            <h5 class="title font-bold">Change Photo</h5>
                                            <span class="font-sm color__grey_dark">Accepts .png, .jpg or .jpeg</span>
                                        </div>
                                        <div class="profile_action_btn">
                                            <label for="upload_imgs" class="btn btn-default-outline btn-sm box_curved loading">
                                                <input type="file" accept=".png, .jpg, .jpeg" name="file" id="upload_imgs" hidden="" :disabled="uploading"
                                                @change="onPhotoChange" class="inputfile">
                                                <span>Change image</span>
                                                <span><Loading :smallSpinner="true" v-if="uploading" /></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="base_divider"></div>

                                <div class="row form_row_group">
                                    <div class="form_group_item col-md-4">
                                        <h4 class="form_row_title font-bold requiredField">Gender</h4>
                                    </div>
                                    <div class="form_group_item col-md-8">
                                        <label for="genderMale" class="radio-inline">
                                            <input type="radio" id="genderMale" checked name="userGender" value="male" v-model="formData.gender">
                                            <span class="label_title caps_upper">Male</span>
                                        </label>
                                        <label for="genderFemale" class="radio-inline">
                                            <input type="radio" id="genderFemale" name="userGender" value="female" v-model="formData.gender">
                                            <span class="label_title caps_upper">Female</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="row form_row_group">
                                    <div class="form_group_item col-md-4">
                                        <h4 class="form_row_title font-bold requiredField">Your Name</h4>
                                        <p class="font-sm color__grey_dark">First name and last name</p>
                                    </div>
                                    <div class="form_group_item col-md-8">
                                        <div class="form-row">
                                            <div class="col-sm-6">
                                                <label for="" class="control-label sr-only">First Name</label>
                                                <input type="text" v-model="formData.firstName" required class="form-control" placeholder="Rubius">
                                            </div>
                                            <div class="col-sm-6">
                                                <label for="" class="control-label sr-only">Last Name</label>
                                                <input type="text" v-model="formData.lastName" required class="form-control" placeholder="Hagrid">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row form_row_group">
                                    <div class="form_group_item col-md-4">
                                        <h4 class="form_row_title font-bold">Email Address</h4>
                                    </div>
                                    <div class="form_group_item col-md-8">
                                        <label for="" class="control-label sr-only">Email Address</label>
                                        <input type="email" class="form-control" disabled :value="user.email">
                                    </div>
                                </div>

                                <div class="row form_row_group">
                                    <div class="form_group_item col-md-4">
                                        <h4 class="form_row_title font-bold requiredField">Phone Number</h4>
                                    </div>
                                    <div class="form_group_item col-md-8">
                                        <label for="" class="control-label sr-only requiredField">Phone Number</label>
                                        <div class="inputaffixed inputPrefixed">
                                            <div class="inputfixture">
                                                <span>+234</span>
                                            </div>
                                            <input type="tel" id="us_phone" v-model="formData.phoneNo" maxlength="11" required
                                            class="inputControl form-control" placeholder="Enter Phone number">
                                        </div>
                                    </div>
                                </div>

                                <div class="row form_row_group">
                                    <div class="form_group_item col-md-4">
                                        <h4 class="form_row_title font-bold requiredField">Contact Address</h4>
                                    </div>
                                    <div class="form_group_item col-md-8">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <input type="text" v-model="formData.address" class="form-control" placeholder="Street Address" required>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-6 required">
                                                    <select class="form-control" v-model="formData.state_id">
                                                        <option v-if="loadingStates" value="">
                                                            loading ...
                                                        </option>
                                                        <option v-else-if="states.length !== 0" value="">Select State</option>
                                                        <option v-for="(st, index) in states" :key="index" :value="st.id">
                                                            {{st.name}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-6 required">
                                                    <input type="text" v-model="formData.city"  class="form-control" placeholder="City / Town">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <aside class="formWidgetProgress col-md-3 col-lg-4">
                <div class="verticalProgressMarkers">
                    <div class="progressMarkerItem stepDone ">
                        <div class="step_line">
                            <div class="stepDetails">
                                <span class="stepNode"></span>
                                <div class="stepInfo">
                                    <h4 class="title font-bold margin_bottom_sm">1. Select Crops</h4>
                                    <p>Select the crops you are interested in, 
                                        and we’ll help you find the best sellers.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="progressMarkerItem stepDone active">
                        <div class="step_line">
                            <div class="stepDetails">
                                <span class="stepNode"></span>
                                <div class="stepInfo">
                                    <h4 class="title font-bold margin_bottom_sm">2. Update your Profile</h4>
                                    <p>Setup your aggregator profile, to get found by investors and off-takers interested in your inventory.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
        
    </main>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
    data() {
        return {
            uploading: false,
            submitting: false,
            formData: {
                city: '',
                phoneNo: '',
                firstName: '',
                lastName: '',
                gender: '',
                address: '',
                state_id: '',
                avatar: ''
            },
            img: '',
            file: '',
            disabledField: false
        }
    },
    computed: {
        ...mapState(['user','states','loadingStates','token', 'expires']),
        checkFields() {
            if (this.formData.phoneNo === '' || this.formData.city === '' || this.formData.firstName === '' || this.formData.lastName === '') {
                return true;
            }
            if (this.formData.state_id === '' || this.formData.address === '' || this.formData.gender === '') {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions(['getStates', 'getFarms']),
        ...mapMutations(['login_user']),
        skip() {
            this.$router.push({
                name: 'offtaker.dashboard'
            })
        },
        
        checkStates() {
            if (this.states.length === 0) {
                this.getStates();
            }
        },
        
        onPhotoChange(e) {
            this.file = event.target.files[0];
            this.img = window.URL.createObjectURL(this.file);
        },
        completedBoarding() {
            this.submitForm();
        },
        submitForm() {
            this.submitting = true;
            if(this.file) {
                this.uploadAvatar();
            } else {
                if(this.user.avatar) {
                    this.formData.avatar = this.user.avatar
                }
                this.updateProfile();
            }
            
        },
        uploadAvatar() {
            this.uploading = true;
            this.$http.uploadFile(this.file)
            .then((response) => {
                this.formData.avatar = response.data.url;
                this.updateProfile();
            })
            .catch((error) => {
                this.$toastr.error(error);
            })
            .finally(() => {
                this.uploading = false;
            })
        },
        updateProfile() {
            this.$http.put('users/profile', this.formData)
            .then((response) => {
                const obj = { 
                    token: this.token,
                    user: response.data,
                    expires_at: this.expires 
                 };
                this.login_user(obj);
                this.$router.push({
                    name: 'offtaker.dashboard'
                })
            })
            .catch((error) => {
                this.$toastr.error(error);
            })
            .finally(() => {
                this.submitting = false;
            })
        },
        assign() {
            this.formData.firstName = this.user.firstName;
            this.formData.lastName = this.user.lastName;
            this.formData.phoneNo = this.user.phoneNo;
            if(this.user.avatar) {
                this.img = this.user.avatar;
            }
        }
    },
    created() {
        this.checkStates()
        this.assign()
    }
}
</script>

<style>

</style>